<!-- Step2 現金 -->
<template>
  <div class="egl-dialog-elm">
    <el-dialog
      :visible="visible"
      :title="$locale('dailyClosing.createDialog.title')"
      width="90%"
      class="egl-dialog cash-table-dialog"
      :modal="false"
      :show-close="true"
      :close-on-click-modal="false"
      @close="closeAction"
    >
      <el-form :disabled="isDetailMode">
        <div class="module-item">
          <h2>{{ $locale("dailyClosing.cashTableDialog.cash") }}</h2>
          <!-- 預金先 -->
          <el-row>
            <el-col :span="5">
              <el-form-item :label="$locale('dailyClosing.cashTableDialog.deposit')" :required="true" style="margin-bottom: 0">
                <el-select class="deposit"
                  v-model="detailData.amountCalculationInfo.bankAccountId"
                  :placeholder="$locale('dailyClosing.cashTableDialog.deposit.placeHolder')"
                >
                  <el-option
                    v-for='item in depositList'
                    :key='item.id'
                    :label='item.name'
                    :value='item.id'
                  ></el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 3 Tables -->
          <el-row :gutter="20">
            <!-- 全レジ内金額の内訳計算表  -->
            <el-col :span="8">
              <div class="module-item-tit">{{ $locale("dailyClosing.cashTableDialog.allCashRegisterAmountsTable.title") }}</div>
              <el-table :data="allCashRegisterAmountsTableData" class="egl-table all-cash-register-amount-table" border>
                <el-table-column :label="$locale('dailyClosing.cashTableDialog.allCashRegisterAmountsTable.th.content')" min-width="50" align="center">
                  <template slot-scope="scope">
                    <p :class="[scope.row.paddingLevel ? scope.row.paddingLevel : '', scope.row.isBold ? 'bold': '', scope.row.isGrey ? 'grey' : '']">{{ scope.row.content }}</p>
                  </template>
                </el-table-column>

                <el-table-column :label="$locale('dailyClosing.cashTableDialog.allCashRegisterAmountsTable.th.amount')" min-width="50" align="center">
                  <template slot-scope="scope">
                    <p :class="[scope.row.isBold ? 'bold': '',  scope.row.isGrey ? 'grey' : '', 'align-right' ]">{{ scope.row.amount | currencyFormatter }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>

            <!-- 金庫金種表 cashTypeTable -->
            <el-col :span="8">
              <div class="module-item-tit">{{ $locale("dailyClosing.cashTableDialog.cashTypeTable.title") }}</div>
              <el-table :data="cashTypeTableData" class="egl-table cash-type-table" border :span-method="cashTypeTableSpanMethod">
                <el-table-column :label="$locale('dailyClosing.cashTableDialog.cashTypeTable.th.cashType')" min-width="50" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.cashType }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$locale('dailyClosing.cashTableDialog.cashTypeTable.th.qty')" min-width="50" align="center">
                  <template slot-scope="scope">
                    <el-input
                      :value="detailData.amountCalculationInfo.actualCash[scope.row.key] | separatorFormatter"
                      maxlength="8"
                      @input="value => inputAction(value, scope.row.key)"
                    ></el-input>
                    <span> {{ $locale('dailyClosing.cashTableDialog.cashTypeTable.sheet') }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$locale('dailyClosing.cashTableDialog.cashTypeTable.th.amount')" min-width="50" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.amount | currencyFormatter }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>

            <!-- 金庫精算表 cashSettlementTable -->
            <el-col :span="8">
              <div class="module-item-tit">{{ $locale("dailyClosing.cashTableDialog.cashSettlementTable.title") }}</div>
              <el-table :data="cashSettlementTableData" class="egl-table cash-settlement-table" border>
                <el-table-column :label="$locale('dailyClosing.cashTableDialog.cashSettlementTable.th.content')" min-width="50" align="center">
                  <template slot-scope="scope">
                    <p :class="[scope.row.paddingLevel ? scope.row.paddingLevel : '', scope.row.isBold ? 'bold': '', scope.row.isGrey ? 'grey' : '']">{{ scope.row.content }}</p>
                  </template>
                </el-table-column>

                <el-table-column :label="$locale('dailyClosing.cashTableDialog.cashSettlementTable.th.amount')" min-width="50" align="center">
                  <template slot-scope="scope">
                    <span class="minus-sign" v-if="scope.row.prop === 'depositAmount' || scope.row.prop === 'balanceTransferred'">-</span>
                    <el-input
                      v-if="scope.row.input"
                      :class="[scope.row.prop === 'depositAmount' || scope.row.prop === 'balanceTransferred' ? 'small' : '']"
                      :value="detailData.amountCalculationInfo.accuratelyCalculate[scope.row.prop] | currencyFormatter(isInitData, null)"
                      :placeholder="$locale('cashierReport.dialog.formField.inputPlaceHolder')"
                      @input="value => inputAction2(value, scope.row.prop)"
                      maxlength="20"
                    ></el-input>
                    <p v-else :class="[scope.row.isBold ? 'bold': '',  scope.row.isGrey ? 'grey' : '', 'align-right' ]">{{ scope.row.amount | currencyFormatter }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-row type="flex" justify="end">
            <el-col :span="10">
              <el-form-item label="備註">
                <el-input type="textarea" :value="detailData.note" rows="5" @input="value => $parent.dailyClosingDetailData.note = value" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          class="egl-btn-white"
          @click="closeAction(true)"
        >{{ $locale("dailyClosing.prevPage") }}</el-button>
        <el-button
          :class="nextBtnDisabled ? 'egl-btn-gray' : 'egl-btn-yellow'"
          :disabled="nextBtnDisabled"
          @click="next_fn"
        >{{ $locale("dailyClosing.createDialog.basicInfo.next") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { digtalParser } from "@/utils/common";

import { updateDayCloseCash } from "@/helpers/service/api/dailyClosingNew";
import {
  fillAllCashRegisterAmounts,
  fillCashTypeTable,
  fillCashSettlementAmounts,
} from "@/assets/js/dailyClosingNew";

export default {
  name: "Cash",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: "",
    },
    depositList: {
      type: Array,
      default: () => [],
    },
    detailData : {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isInitData: true,
    };
  },
  computed: {
    isDetailMode() {
      return this.actionType === "detail";
    },
    allCashRegisterAmountsTableData() {
      const _tableData = fillAllCashRegisterAmounts(this.detailData);
      return _tableData;
    },
    cashTypeTableData() {
      const _tableData = fillCashTypeTable(this.detailData);
      return _tableData;
    },
    cashSettlementTableData() {
      const _tableData = fillCashSettlementAmounts(this.detailData);
      return _tableData;
    },
    nextBtnDisabled() {
      const _nextBtnDisabled = !this.detailData
      || !this.detailData.amountCalculationInfo
      || !this.detailData.amountCalculationInfo.bankAccountId;

      return _nextBtnDisabled;
    },
  },
  methods: {
    closeAction(_goPrevStep = false, _goNextStep = false) {
      this.$emit("closeDialogFn", {
        name: "step2",
        prevStep: _goPrevStep,
        nextStep: _goNextStep,
      });
    },
    inputAction(value, key) {
      const _value = digtalParser(value);
      if (this.detailData.amountCalculationInfo.actualCash) {
        this.detailData.amountCalculationInfo.actualCash[key] = _value;
        // this.detailData.amountCalculationInfo.accuratelyCalculate.safeTotalToday
      }
    },
    inputAction2(value, key) {
      const negativeCheck = ["smallCashTransfer", "pettyCash"];
      const _isNegative = negativeCheck.includes(key);
      const _value = digtalParser(value, _isNegative);

      if (this.detailData.amountCalculationInfo.accuratelyCalculate) {
        this.detailData.amountCalculationInfo.accuratelyCalculate[key] = _value;

        if (key === "smallCashTransfer") {
          const _$target = this.cashSettlementTableData.find(_cst => _cst.prop === "pettyCash");
          this.detailData.amountCalculationInfo.accuratelyCalculate.pettyCash = _$target.amount;
        } else if (key === "pettyCash") {
          let _$safeTotalToday = this.cashSettlementTableData.find(_cst => _cst.prop === "safeTotalToday");
          _$safeTotalToday = _$safeTotalToday.amount === "-" ? 0 : _$safeTotalToday.amount;
          let _$cashPrevious = this.cashSettlementTableData.find(_cst => _cst.prop === "cashPrevious");
          _$cashPrevious = _$cashPrevious.amount === "-" ? 0 : _$cashPrevious.amount;
          let _$depositAmount = this.cashSettlementTableData.find(_cst => _cst.prop === "depositAmount");
          _$depositAmount = _$depositAmount.amount === "-" ? 0 : _$depositAmount.amount;
          let _$balanceTransferred = this.cashSettlementTableData.find(_cst => _cst.prop === "balanceTransferred");
          _$balanceTransferred = _$balanceTransferred.amount === "-" ? 0 : _$balanceTransferred.amount;

          const result = _$safeTotalToday + _value + _$cashPrevious - _$depositAmount - _$balanceTransferred;
          this.detailData.amountCalculationInfo.accuratelyCalculate.cashCarried = result;
        }
      }
    },
    cashTypeTableSpanMethod({ rowIndex, columnIndex }) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };

      let dataLength = this.cashTypeTableData.length;

      if (rowIndex + 1 === dataLength) {
        if (columnIndex == 0) {
          obj.colspan = 2;
        } else if (columnIndex == 2) {
          obj.colspan = 1;
        } else {
          obj.colspan = 0;
        }
      }

      return obj;
    },
    async next_fn() {
      if (this.isDetailMode) {
        this.closeAction(false, true);
      } else {
        let { amountCalculationInfo: requestParam, note } = tranfResData(this.detailData);
        this.cashSettlementTableData.forEach(_data => {
          const [_mainProp, _subProp] = _data.apiProp.split("_");
          const hasSubItem = ["cashRecoveryPayment", "totalInsufficient"];

          if (!_subProp && !hasSubItem.includes(_mainProp)) {
            requestParam.accuratelyCalculate[_mainProp] = typeof _data.amount === "number" ? _data.amount : 0;

          } else {
            requestParam.accuratelyCalculate[_mainProp] = {
              ...(requestParam.accuratelyCalculate[_mainProp] ? requestParam.accuratelyCalculate[_mainProp] : {}),
            };
            if (_subProp) {
              requestParam.accuratelyCalculate[_mainProp][_subProp] = typeof _data.amount === "number" ? _data.amount : 0;
            }
          }
        });

        await updateDayCloseCash({
          ...requestParam,
          note
        }).then(res => {
          if (res.success) {
            const _resData = res.data ? tranfResData(res.data) : {};
            const { accountPayableInCashs: _existAccountPayableInCashs } = this.detailData;
            const _editData = {
              ..._resData,
              salesAccounts: _existAccountPayableInCashs.salesAccounts,

            };

            const _accountPayableInCashs = {
              create: _resData,
              edit: _editData,
              detail: _existAccountPayableInCashs,
            };

            this.$emit("update:detailData", {
              ...tranfResData(this.detailData),
              accountPayableInCashs: _accountPayableInCashs[this.actionType],
            });

            this.closeAction(false, true);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
  .minus-sign {
    vertical-align: middle;
    line-height: 40px;
  }
</style>

